<template>
  <div @click="$emit('toggleRound', votingRound.id)"
    class="mb-3 position-relative sidebar-card highlight-hover p-3 rounded h5"
    :class="selected ? 'bg-theme' : 'bg-blur-darker text-white'">
    <i class="fas fa-vote-yea"></i> {{ label }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { label } from "@/entrypoints/shared/voting_rounds_helper";
import type { PropType, ConferenceVotingRound } from "@/types";

export default defineComponent({
  name: "VotingRound",
  props: {
    votingRound: {
      type: Object as PropType<ConferenceVotingRound>,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      return label(this.votingRound, this.$i18n.locale);
    },
  },
});
</script>

<style scoped>
.highlight-hover:hover {
  cursor: pointer;
  box-shadow: 0 0 0 2px white;
}
</style>
